<template>
<div class="Blk-Btn">

  <button @click.prevent="more"
    class="button"
    :disabled= 'desacMas'
    v-show="verNuevo"
    v-if= !!botones[0]>
    <span class="icon-icoMasSolo ico"></span>Nuevo</button>

  <button @click.prevent="salirMore"
    class="button" v-show="!verNuevo">
    <span class="icon-icoMasSolo ico"></span>Cancelar</button>

  <button @click="edit"
    class="button"
    :disabled= 'desacEdit'
    v-show="verEditar"
    v-if= !!botones[1]>
    <span class="icon-icoEditSolo ico"></span>Editar</button>

  <button @click="salirEdit"
    class="button" v-show="!verEditar">
    <span class="icon-icoEditSolo ico"></span>Cancelar</button>

  <button @click="del"
    class="button"
    :disabled= 'desacMenos'
    v-if= !!botones[2]>
    <span class="icon-icoMenosSolo ico"></span>Eliminar</button>

  <button @click="save"
    class="button"
    :disabled= 'desacSave'
    v-if= !!botones[3]>
    <span class="icon-icoSubirNube ico"></span>Guardar</button>
</div>
</template>

<script>
export default {
  props: {
    desacMas: Boolean,
    desacEdit: Boolean,
    desacMenos: Boolean,
    desacSave: Boolean,
    botones: {
      type: Array,
      default (rawProps) {
        return [1, 1, 1, 1]
      }
    }
  },
  emits: ['nuevo', 'editar', 'save', 'del'],

  data () {
    return {
      verEditar: true,
      verNuevo: true
    }
  },
  methods: {
    more () {
      this.verNuevo = false
      this.$emit('nuevo')
    },
    salirMore () {
      this.verNuevo = true
      this.$emit('nuevo')
    },
    edit () {
      this.$emit('editar')
      this.verEditar = false
    },
    salirEdit () {
      this.$emit('editar')
      this.verEditar = true
    },
    save () {
      this.$emit('save')
      this.verNuevo = true
      this.verEditar = true
    },
    del () {
      this.$emit('del')
      this.verNuevo = true
      this.verEditar = true
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.button{
  display: inline-flex;
  width: 80%;
  /*height: 70%;*/
  align-content:center;
  align-self: center;
  align-items: center;
  background-color: transparent;
  border-color: transparent;
  /* font-family: 'OpenL'; */
  font-weight:400 ;
  font-size: 16px;
}
.button:disabled + eti {
  color: darkgrey;
}
button:hover:enabled{
  background-color: rgb(220, 228, 227);
  cursor: pointer;
  /* transform: scale(1.08); */
}
.ico:hover{
  transform: scale(1.08);
}
.icon-icoMasSolo{
  color: var(--az-ico);
  font-size: 1.2em;
  padding-left: 5px;
  padding-right: 12px;
}
.icon-icoEditSolo{
  color: var(--az-ico);
  font-size: 1.3em;
  padding-left: 5px;
  padding-right: 11px;
  padding-top: 4px;
}
.icon-icoMenosSolo{
  color: var(--az-ico);
  font-size: 1.3em;
  padding-left: 4px;
  padding-right: 13px;
}
.icon-icoSubirNube{
  color: var(--az-ico);
  font-size: 1.2em;
  padding-left: 3px;
  padding-right: 17px;
}
@media screen and (max-width: 600px){
  .Blk-Btn {
    width: 95vw;
    display: flex;
    flex-direction: row;
    justify-content:space-evenly;
    margin: 4vw 0 2vw 0;
    column-gap:4px;
  }
  .button {
    height:4vh;
    border: solid white 0.5px;
    border-radius: 5px;
    font-size: 14px;
  }
  .icon-icoMasSolo{
    font-size: 1.2em;
    padding-left: 7px;
    padding-right: 10px;
    padding-bottom: 2px;
  }
.icon-icoEditSolo{
    font-size: 1.3em;
    padding-left: 7px;
    padding-right: 8px;
    padding-top: 4px;
    padding-bottom: 6px;
}
  .icon-icoMenosSolo{
    font-size: 1.3em;
    padding-left: 4px;
    padding-right: 8px;
  }
  .icon-icoSubirNube{
    font-size: 1.2em;
    padding-left: 3px;
    padding-right: 10px;
    padding-bottom: 2px;
  }
}
</style>
